<!--
   Created by qing on 2020/10/10
   Des:
-->
<template>
  <div>
    <van-cell class="ry-form__sub-item-button" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>

        <div
          class="btn"
          :class="{'disabled': btnDisabled}"
          :style="{backgroundColor: current.buttonColor}"
          @click="onClickBtn">
          <i v-if="loading" class="el-icon-loading"></i>
          {{current.buttonName}}
        </div>
      </template>

    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__item-button-compact">

      <van-field :label="current.title">
        <template #input>
          <div
            class="btn"
            :class="{'disabled': btnDisabled}"
            :style="{backgroundColor: current.buttonColor}"
            @click="onClickBtn">
            <i v-if="loading" class="el-icon-loading"></i>
            {{current.buttonName}}
          </div>
        </template>
      </van-field>
    </div>

    <RySelectPopup
      ref="rySelectPopup"
      :title="current.title"
      @selectComplete="selectComplete">
    </RySelectPopup>

    <create-form-apply
      :key="current.dataId"
      ref="createFormApply"
      :appId="current.applyAppId"
      :formId="current.applyFormId"
      :needButton="false"
      :formSetValue="formSetValue"
      @submitCallback="applySuccess">
    </create-form-apply>
  </div>
</template>

<script>
  import { current } from './mixin'
  import {BUTTON_TYPE_APPLY_FORM, BUTTON_TYPE_PLUGIN} from "../../types";
  import CreateFormApply from "../../../component/CreateFormApply";
  export default {
    mixins: [current],
    data() {
      return {
        initPer: false,
        hasFillForm: false,
        formSetValue: null
      }
    },
    components: {CreateFormApply},
    created() {
    },
    computed: {
      btnDisabled() {
        if (this.current.buttonType === BUTTON_TYPE_APPLY_FORM) {
          return this.isReadOnly
        }
        return this.isRead || this.isReadOnly
      }
    },
    methods: {
      onClickBtn() {
        console.log('pluginConfig',this.current.pluginConfig)
        if (this.btnDisabled || this.loading) {
          return
        }
        if (this.current.buttonType === BUTTON_TYPE_PLUGIN) {
          if (!this.current.pluginConfig) {
            this.$toast.fail('按钮未绑定插件')
            return
          }
          if (this.current.showAlert) {

            this.$dialog.confirm({
              title: this.current.showTitle,
              message: this.current.alertText,
              confirmButtonText: this.current.confirmText,
              cancelButtonText: this.current.cancelText,
            })
              .then(() => {
                this.submitData()
              })
              .catch(() => {
              });
          } else {
            this.submitData()
          }
        } else if (this.current.buttonType === BUTTON_TYPE_APPLY_FORM) {

          if (this.current.root.isLink) {
            this.$toast.fail('外链不允许发起新表单')
            return;
          }

          if (!this.current.applyAppId || !this.current.applyFormId) {
            this.$toast.fail('按钮设置错误')
            return
          }
          if (this.initPer) {
            if (this.hasFillForm) {

              const loading = this.$toast.loading()
              this.$store.dispatch('actionFormButtonApplyData', {
                appId: this.current.root.appId,
                formId: this.current.root.formId,
                data: this.current.root.getValues(),
                buttonId: this.current.dataId
              }).then(res => {
                this.formSetValue = res
                if (this.$refs.createFormApply) {
                  this.$refs.createFormApply.close()
                }
              }).catch(console.error)
                .finally(() => {loading.clear()})

            } else {
              this.$toast.fail('您暂无权限发起表单，请联系管理员')
            }
          } else {
            const loading = this.$loading()
            this.$store.dispatch('actionFormFillPermission', {
              appId: this.current.applyAppId,
              formId: this.current.applyFormId,
            }).then(res => {
              this.initPer = true
              this.hasFillForm = res.hasPer
              if (this.hasFillForm) {

                const loading = this.$toast.loading()
                this.$store.dispatch('actionFormButtonApplyData', {
                  appId: this.current.root.appId,
                  formId: this.current.root.formId,
                  data: this.current.root.getValues(),
                  buttonId: this.current.dataId
                }).then(res => {
                  this.formSetValue = res
                  if (this.$refs.createFormApply) {
                    this.$refs.createFormApply.close()
                  }
                }).catch(console.error)
                  .finally(() => {loading.clear()})
              } else {
                this.$toast.fail('您暂无权限发起表单，请联系管理员')
              }
            }).catch(console.error)
              .finally(() => {
                loading.close()
              })
          }
        }

      },
      applySuccess() {
      }
    }
  }
</script>

<style lang="less">

  .ry-form__sub-item-button, .ry-form__item-button-compact {
    padding: 10px 20px;

    .btn {
      width: 100%;
      height: 36px;
      line-height: 34px;
      color: #fff;
      max-width: 350px;
      border-radius: 2px;
      text-align: center;
      text-decoration: none;
      font-size: 14px;
      border: 1px solid transparent;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transition: background .3s ease 0s;
      transition-duration: .3s;
    }

    .disabled {
      background-color: #9e9e9e !important;
    }
  }

  .ry-form__item-button-compact {
    padding: 0;
  }
</style>
